(() => {
  const end = Date.parse('2027-01-01T00:00:00+01:00');
  const initialised = new WeakSet();
  function init(root = document) {
    root.querySelectorAll('[data-obs-card]').forEach(card => {
      if (initialised.has(card)) return;
      initialised.add(card);
      card.classList.add('obs-karte--js');
      const buttons = [...card.querySelectorAll('[data-obs-choice]')];
      const choose = index => {
        card.querySelectorAll('[data-obs-state]').forEach(node => { node.hidden = Number(node.dataset.obsState) !== index; });
        buttons.forEach((button, i) => { button.setAttribute('aria-checked', String(i === index)); button.tabIndex = i === index ? 0 : -1; });
        const state = card.querySelector(`[data-obs-set-url][data-obs-state="${index}"]`);
        if (state) card.querySelector('[data-obs-scene-link]').href = state.dataset.obsSetUrl;
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => choose(index));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
          event.preventDefault();
          const next = (index + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : buttons.length - 1)) % buttons.length;
          choose(next);
          buttons[next].focus();
        });
      });
      choose(0);
    });
    root.querySelectorAll('[data-obs-slider]').forEach(slider => {
      if (initialised.has(slider)) return;
      initialised.add(slider);
      const allSlides = [...slider.querySelectorAll('[data-obs-slide]')];
      const track = slider.querySelector('.obs-slide-track');
      const dots = [...slider.querySelectorAll('[data-obs-dot]')];
      const dotLabels = dots.map(dot => dot.getAttribute('aria-label') || '');
      const controls = slider.querySelector('.obs-carousel-controls');
      const pause = slider.querySelector('[data-obs-pause]');
      const previous = slider.querySelector('[data-obs-prev]');
      const nextButton = slider.querySelector('[data-obs-next]');
      const mobile = matchMedia('(max-width:749px)');
      let slides = [];
      let index = 0;
      let playing = !matchMedia('(prefers-reduced-motion: reduce)').matches;
      const updatePause = () => {
        if (!pause) return;
        const active = playing && slides.length > 1;
        pause.textContent = active ? 'Ⅱ' : '▷';
        pause.setAttribute('aria-label', active ? pause.dataset.pauseLabel : pause.dataset.playLabel);
      };
      const stop = () => { playing = false; updatePause(); };
      const show = (next, manual = false) => {
        index = slides.length ? (next + slides.length) % slides.length : 0;
        track.style.transform = `translateX(-${index * 100}%)`;
        const current = slides[index];
        allSlides.forEach(slide => {
          slide.setAttribute('aria-hidden', String(slide !== current));
          slide.inert = slide !== current;
          slide.classList.toggle('obs-slide--current', slide === current);
        });
        dots.forEach((dot, i) => {
          const selected = allSlides[i] === current;
          dot.classList.toggle('obs-dot--selected', selected);
          dot.setAttribute('aria-current', String(selected));
        });
        if (manual) stop();
      };
      const rebuild = () => {
        slides = allSlides.filter(slide => !mobile.matches || !slide.hasAttribute('data-nur-desktop'));
        const multiple = slides.length > 1;
        slider.hidden = slides.length === 0;
        slider.classList.toggle('obs-slider--single', slides.length === 1);
        slider.classList.toggle('obs-slider--empty', slides.length === 0);
        [controls, pause, previous, nextButton].forEach(control => { if (control) control.hidden = !multiple; });
        dots.forEach((dot, i) => {
          const order = slides.indexOf(allSlides[i]);
          dot.hidden = !multiple || order < 0;
          dot.tabIndex = dot.hidden ? -1 : 0;
          if (order >= 0) {
            let number = 0;
            dot.setAttribute('aria-label', dotLabels[i].replace(/\d+/g, () => String(number++ === 0 ? order + 1 : slides.length)));
          }
        });
        show(0);
        updatePause();
      };
      pause?.addEventListener('click', () => { if (slides.length > 1) playing = !playing; updatePause(); });
      previous?.addEventListener('click', () => { if (slides.length > 1) show(index - 1, true); });
      nextButton?.addEventListener('click', () => { if (slides.length > 1) show(index + 1, true); });
      dots.forEach((dot, i) => dot.addEventListener('click', () => {
        const order = slides.indexOf(allSlides[i]);
        if (slides.length > 1 && order >= 0) show(order, true);
      }));
      slider.addEventListener('keydown', event => {
        if (event.defaultPrevented || slides.length < 2 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1);
        show(next, true);
        if (event.target.matches('[data-obs-dot]')) dots[allSlides.indexOf(slides[index])]?.focus();
      });
      mobile.addEventListener('change', rebuild);
      ['pointerenter', 'focusin', 'touchstart'].forEach(name => slider.addEventListener(name, stop, { passive: true }));
      const visibility = () => { if (document.hidden) stop(); };
      document.addEventListener('visibilitychange', visibility);
      const timer = setInterval(() => {
        if (!slider.isConnected) {
          clearInterval(timer);
          document.removeEventListener('visibilitychange', visibility);
          mobile.removeEventListener('change', rebuild);
          return;
        }
        if (slides.length > 1 && playing && !document.hidden) show(index + 1);
      }, 6000);
      rebuild();
    });
    countdown();
  }
  function countdown() {
    const seconds = Math.floor((end - Date.now()) / 1000);
    const days = Math.floor(seconds / 86400);
    document.querySelectorAll('[data-obs-countdown]').forEach(node => {
      if (seconds <= 0) { node.hidden = true; return; }
      node.textContent = days === 0 ? node.dataset.last : node.dataset.normal.replace('{tage}', String(days));
    });
    document.querySelectorAll('[data-obs-days]').forEach(node => { node.textContent = node.dataset.normal.replace('{tage}', String(Math.max(0, days))); });
    if (seconds <= 0) {
      document.querySelectorAll('[data-obs-promo]').forEach(node => { node.hidden = true; });
      document.querySelectorAll('.obs-price').forEach(node => {
        const price = node.querySelector('strong');
        if (price) node.replaceChildren(price.cloneNode(true), document.createTextNode('\u00a0€'));
      });
    }
    const mode = document.querySelector('[data-obs-mode]')?.dataset.obsMode || document.querySelector('.obw-set-purchase')?.dataset.modus;
    if (seconds <= 0 || mode === 'aus') {
      const announcement = document.querySelector('.text-block--obw_ann_2');
      if (announcement) { announcement.hidden = true; announcement.replaceChildren(); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  setInterval(countdown, 60000);
})();
